module.exports = __webpack_public_path__ + "z/proximanova-boldit-webfont.9f8b55b7.svg";